import { clone } from 'lodash'

export const getterTypes = {
    productsAll: 'productsAll',
    productsCategories: 'productsCategories',
    productsStatuses: 'productsStatuses',
    productsBrands: 'productsBrands',
    productsBrandsSkeleton: 'productsBrandsSkeleton',
    productsFind: 'productsFind',
    productsBrandsFind: 'productsBrandsFind',    
    productsFilesFind: 'productsFilesFind',    
    productsSkeleton: 'productsSkeleton',
    productsValidationModal: 'productsValidationModal',
    productsValidationErrors: 'productsValidationErrors',
    productsValidationMessage : 'productsValidationMessage',
}

export default {
    [getterTypes.productsAll]: state => state.products,
    [getterTypes.productsCategories]: state => state.categories,
    [getterTypes.productsStatuses]: state => state.statuses,
    [getterTypes.productsBrands]: state => state.productsBrands,
    [getterTypes.productsFind]: state => id => state.products.find(temp => temp.id == parseInt(id)),
    
    [getterTypes.productsFilesFind]: state => productId => state.productsFiles.filter(temp => temp.productId == parseInt(productId)).sort((a,b) => a.position > b.position),

    [getterTypes.productsBrandsFind]: state => brandId => state.productsBrands.find(temp => temp.id == parseInt(brandId)),
    [getterTypes.productsSkeleton]: state => clone(state.productsSkeleton),
    [getterTypes.productsBrandsSkeleton]: state => clone(state.productsBrandsSkeleton),
    [getterTypes.productsValidationModal]: state => state.productsValidationModal,
	[getterTypes.productsValidationErrors]: state => state.productsValidationErrors,
	[getterTypes.productsValidationMessage]: state => prop => {
		const temp = state.productsValidationErrors[prop]
		return Array.isArray(temp)
			? temp[0]
			: temp
	},
}